import script from "./MyProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProxy.vue?vue&type=script&setup=true&lang=js"

import "./MyProxy.vue?vue&type=style&index=0&id=44895446&lang=css"
import "./MyProxy.vue?vue&type=style&index=1&id=44895446&scoped=true&lang=css"
import "./MyProxy.vue?vue&type=style&index=2&id=44895446&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44895446"]])

export default __exports__